import React from 'react';
import { connect } from 'react-redux';
import {
    Collapse, Divider, Spin, Tag,
} from 'antd';
import { Button, Paper } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { getBikeUpgradesList } from '../../requests/bike_lead_upgrades_request';
import BikeUpgradesModal from './BikeUpgradesModal';
import { getLeadProfileRequest } from '../../redux/actions/get_lead_profile.actions';
import { OTHER_CATEGORY_ID } from '../../../constants/bikeUpgrades';

const { Panel } = Collapse;

class BikeUpgrades extends React.Component {
    constructor(props) {
        super(props);

        // const initialNote = lodash.get(this.props, 'blemish_report.questions.question_46.note') || '';

        this.state = {
            isFetching: false,
            bikeUpgradesList: null,
            bikeUpgradesCategories: null,
            isModalOpen: false,
        };
    }

    componentDidMount() {
        this.handleGetBikeUpgrades();
    }

    handleGetBikeUpgrades = async () => {
        this.setState({ isFetching: true });
        const response = await getBikeUpgradesList();

        this.setState({
            bikeUpgradesCategories: (Array.isArray(response?.options) ? response?.options : [])?.filter((upgrade) => !upgrade.parent_id),
            bikeUpgradesList: Array.isArray(response?.options) ? response?.options : [],
            isFetching: false,
        });
    };

    buildBikeLeadUpgradesTree = () => {
        const upgradesTree = {};
        const leadUpgrades = this.props.bikeLeadUpgrades?.map((upgrade) => ({
            ...upgrade.ref_bike_lead_upgrades,
            name: upgrade.additional_mod || upgrade.ref_bike_lead_upgrades.name,
        })) || [];

        this.state.bikeUpgradesCategories.forEach((category) => {
            upgradesTree[category._id] = { ...category };
        });

        if (Array.isArray(leadUpgrades) && leadUpgrades.length) {
            leadUpgrades.forEach((upgrade) => {
                if (upgrade.parent_id) {
                    if (!upgradesTree[upgrade.parent_id].subCategories) {
                        upgradesTree[upgrade.parent_id].subCategories = {};
                    }
                    upgradesTree[upgrade.parent_id].subCategories[upgrade.name] = { ...upgrade };
                } else {
                    if (!upgradesTree[OTHER_CATEGORY_ID].subCategories) {
                        upgradesTree[OTHER_CATEGORY_ID].subCategories = {};
                    }
                    upgradesTree[OTHER_CATEGORY_ID].subCategories[upgrade.name] = { ...upgrade };
                }
            });
        }

        return upgradesTree;
    };

    handleIsModalOpen = (isOpen) => {
        this.setState({ isModalOpen: isOpen });
    };

    render() {
        let bikeLeadUpgradesTree = null;

        if (this.state.bikeUpgradesCategories && !this.props.isFetchingUpgrades) {
            bikeLeadUpgradesTree = this.buildBikeLeadUpgradesTree();
        }

        return (
            <Spin spinning={this.props.loading || this.props.isFetchingUpgrades} tip="Fetching...">
                <Paper style={{ padding: 24, marginTop: 10 }}>
                    <h3>Additional/Aftermarket Parts</h3>

                    {bikeLeadUpgradesTree && !this.props.isFetchingUpgrades
                        ? (
                            <Collapse expandIconPosition="right">
                                {Object.keys(bikeLeadUpgradesTree)?.map((categoryId) => (
                                    <Panel
                                        header={bikeLeadUpgradesTree[categoryId].name}
                                        extra={bikeLeadUpgradesTree[categoryId].subCategories
                                            ? <Tag color="#87d068">Yes</Tag>
                                            : <Tag color="#f50">No</Tag>
                                        }
                                        key={categoryId}
                                    >
                                        {
                                            bikeLeadUpgradesTree[categoryId].subCategories
                                                ? Object.keys(bikeLeadUpgradesTree[categoryId].subCategories)
                                                    .map((subCategoryName, idx, array) => (
                                                        <div key={subCategoryName} style={{ position: 'relative' }}>
                                                            <div>
                                                                {subCategoryName}
                                                            </div>
                                                            {(array.length - 1 !== idx)
                                                                ? <Divider style={{ margin: '5px 0' }} />
                                                                : ''
                                                            }
                                                        </div>
                                                    ))
                                                : ''
                                        }
                                    </Panel>
                                ))}
                            </Collapse>
                        )
                        : ''
                    }

                    <div style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: 10 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={() => this.handleIsModalOpen(true)}
                            disabled={this.state.isFetching}
                        >
                            Edit
                        </Button>
                    </div>

                    {
                        !this.props.isFetchingUpgrades && this.state.bikeUpgradesList
                            ? (
                                <BikeUpgradesModal
                                    isModalOpen={this.state.isModalOpen}
                                    handleIsModalOpen={this.handleIsModalOpen}
                                    bikeUpgradesList={this.state.bikeUpgradesList}
                                    bikeUpgradesCategories={this.state.bikeUpgradesCategories}
                                    bikeLeadUpgrades={this.props.bikeLeadUpgrades}
                                    bikeLeadId={this.props.bikeLeadId}
                                    getLeadProfileRequest={this.props.getLeadProfileRequest}
                                />
                            )
                            : ''
                    }
                </Paper>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    const bikeLeadUpgrades = state.Leads.Lead_profile.Ref_bike_lead?.bike_details?.upgrades;
    const bikeLeadId = state.Leads.Lead_profile.Ref_bike_lead?.bike_details?._id;
    const isFetchingUpgrades = state.Leads.Lead_profile.Ref_bike_lead?.isFetchingUpgrades;
    const { loading } = state.Leads.Lead_profile.Lead_general;

    return {
        bikeLeadUpgrades,
        bikeLeadId,
        loading,
        isFetchingUpgrades,
    };
};

export default connect(mapStateToProps, { getLeadProfileRequest })(BikeUpgrades);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/BikeUpgrades.js